export const ALLOWED_FSB_DISCOUNT_CODES: string[] = [
  "FSB_Member_Discount_0124",
];

export const allowedFsbMemberDiscounts = (code?: string | null): boolean => {
  if (code === null || code === undefined) {
    return false;
  }
  const lowerCaseCode = code.toLowerCase();
  return ALLOWED_FSB_DISCOUNT_CODES.map((i) => i.toLowerCase()).includes(
    lowerCaseCode
  );
};
